import { projectManagementApi } from '@/includes/projectManagementApi';

const pmProjectSettingsService = {
  async getSettings(projectId) {
    const response = await projectManagementApi.get(`/projects/${projectId}/settings`);
    return response.data;
  },

  async updateSettings(projectId, payload) {
    const response = await projectManagementApi.patch(
      `/projects/${projectId}/settings`,
      payload,
    );
    return response.data;
  },

  async listMembers(projectId) {
    const response = await projectManagementApi.get(`/projects/${projectId}/members`);
    return response.data;
  },

  async addMembers(projectId, userIds) {
    const response = await projectManagementApi.post(`/projects/${projectId}/members`, {
      userIds,
    });
    return response.data;
  },

  async replaceMembers(projectId, userIds) {
    const response = await projectManagementApi.put(`/projects/${projectId}/members`, {
      userIds,
    });
    return response.data;
  },

  async updateMemberRole(projectId, userId, role) {
    const response = await projectManagementApi.patch(
      `/projects/${projectId}/members/${userId}`,
      { role },
    );
    return response.data;
  },

  async removeMember(projectId, userId) {
    const response = await projectManagementApi.delete(
      `/projects/${projectId}/members/${userId}`,
    );
    return response.data;
  },

  async requestClosure(projectId, payload = {}) {
    const response = await projectManagementApi.post(
      `/projects/${projectId}/closure/request`,
      payload,
    );
    return response.data;
  },

  async listPendingClose() {
    const response = await projectManagementApi.get('/project-closures/pending');
    return response.data;
  },

  async approveClosure(projectId) {
    const response = await projectManagementApi.post(
      `/projects/${projectId}/closure/approve`,
    );
    return response.data;
  },

  async reactivate(projectId, payload = {}) {
    const response = await projectManagementApi.post(
      `/projects/${projectId}/closure/reactivate`,
      payload,
    );
    return response.data;
  },
};

export default pmProjectSettingsService;
